<template>
	<j-base-multi-select-with-flexible-value
		:id="id"
		:options="options"
		:value="value"
		:placeholder="$t('select_product')"
		:allowMultiselect="false"
		:allowSearch="true"
		:allowLocalSearch="true"
		:status="status"
		:isLoading="isLoading"
		valueKey="id"
		nameKey="name"
		:size="size"
		@input="onInput($event)"
		@focus="fetch"
	/>
</template>

<script>
/**
 * This component is reposnible for displaying all available products
 * @returns Array with one Objects inside that represents selected product
 */

import JBaseMultiSelectWithFlexibleValue from "@/components/JBaseMultiSelectWithFlexibleValue"
import api from "../api/"
import get from "lodash.get"

export default {
	components: { JBaseMultiSelectWithFlexibleValue },
	props: {
		value: {
			validator(value) {
				return value === null || value instanceof Array
			},
			required: true
		},
		id: {
			type: String,
			required: false
		},
		status: {
			type: String,
			required: false
		},
		insuranceType: {
			validator(value) {
				return value === null || typeof value === "string"
			},
			required: false,
			default: null
		},
		size: {
			type: String,
			required: false,
			default: "medium"
		}
	},

	data: () => ({
		options: [],
		isLoading: false
	}),

	methods: {
		onInput(value) {
			this.$emit("input", value)
		},

		async fetch() {
			const sort = { fieldName: "id", type: "desc" }

			this.isLoading = true
			let res = await api.products({ sort })
			this.isLoading = false

			if (res.errors) {
				return
			}

			const options = res.data.products_2.list.map(item => ({
				...item,
				name: `${item.name} ${
					item?.insurer?.name ? "- " + item?.insurer?.name : ""
				}`
			}))

			// If type was passed in props, show only products of this type
			if (this.insuranceType)
				this.options = options.filter(
					item => item.productId.type === this.insuranceType
				)
			else this.options = options
		}
	}
}
</script>
